import boxImageUrlFormatter from '../../utilities/boxImageUrlFormatter'

export const convertPromotionApiResponseToRewards = promotion => {
  const {
    id,
    name,
    creditUsed: creditsUsed,
    maximumSelections,
    coupon,
    creditsAvailable,
    redemptionId,
    surveyResponse,
    couponExpiresAt,
    distributionExpiresAt,
    dlistExpiresAt,
    title,
  } = promotion
  const contentItems = promotion.contentItems.map(
    ({
      activationKey,
      staticKey,
      content,
      imageUrl,
      thirdPartyRedeemed,
      legalAttributeDescription,
      legalAttributeTitle,
      legalAttributeUrl,
    }) => ({
      contentId: content.id,
      name: content.name,
      active: content.active,
      display: content.display,
      activationKey,
      staticKey,
      provider: content.content_provider.name,
      contentRatings: content.contentRatings,
      releaseDate: content.releaseDate,
      expiryDate: content.expiryDate,
      imageUrl: boxImageUrlFormatter(imageUrl || content.boxImgName),
      thirdPartyRedeemed,
      legalAttributeDescription,
      legalAttributeTitle,
      legalAttributeUrl,
    })
  )
  return {
    id,
    name,
    coupon,
    creditsUsed,
    creditsAvailable,
    maximumSelections,
    contentItems,
    redemptionId,
    surveyResponse,
    couponExpiresAt,
    distributionExpiresAt,
    dlistExpiresAt,
    title,
  }
}

export const filterMyArchive = archive => {
  const {
    active,
    contentKey,
    couponKey,
    content: {
      boxImgName,
      expiryDate,
      name,
      staticKey,
      content_provider: { name: provider },
    },
    status,
  } = archive

  return {
    active,
    contentKey,
    couponKey,
    boxImgName,
    expiryDate,
    name,
    status,
    staticKey,
    provider,
  }
}
